// @flow
import * as React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import type { TPlayersById } from "../../../../modules/types";
import colors from '../../../../assets/css/colors';
import { below } from '../../../../assets/css/media';
import {
	HistoryTradeInCell,
	TransactionPlayers,
	TransactionPlayersWrapper,
	HistoryTradeOutCell,
	BorderedIcon,
} from '../../../../components';
import TradeTitleWrapper from '../tradeTitleWrapper';
import Trade from '../../../../components/Icons/Trade';
import FA from '../../../../components/Icons/FA';

type Props = {
	trade: Array<Object>,
	players_by_id: TPlayersById,
}

const BorderedIconStyled = styled(BorderedIcon)`
	font-size: 2em;
`;

const TradeTitleStyled = styled.h3`
	text-transform: uppercase;
	font-size: 12px;
	font-weight: 900;
	color: ${colors.nrlDarkGreen};
`;

const DeskSpan = styled.span`
	${below.desktop`
		display: none;
	`}
`;

const TradeTitleStyledDrop = styled(TradeTitleStyled)`
	margin-left: auto;
`;

const TransactionPlayersLeft = styled(TransactionPlayers)`
	padding-right: 20px;
	${below.desktop`
		padding-right: 5px;
	`}
`;

const StyledHistoryTradeInCell = styled(HistoryTradeInCell)`

`;

const StyledHistoryTradeOutCell = styled(HistoryTradeOutCell)`

`;

const TransactionPlayersRight = styled(TransactionPlayers)`
	padding-left: 20px;
	${below.desktop`
		padding-left: 5px;
	`}
`;

const TransactionPlayersRightJustDrop = styled(TransactionPlayersRight)`
	margin-left: auto;
`;



const StyledTransactionPlayersWrapper = styled(TransactionPlayersWrapper)`
	width: 100%;
	padding-left: 0px;
	padding-right: 0px;
	${below.desktop`
		text-align: center;

	`}
`;

const TransactionHistoryDiv = styled.div`
	width: 100%;
`;

const TransactionPlayersWrapperInside = styled(TransactionPlayersWrapper)`
	${below.desktop`
		display: inline-flex;
	`}
`;

const PlayerPTag = styled.p`
	${below.desktop`
		text-align: left;
	`}
`;

class TransactionHistoryRFARow extends React.Component<Props> {


	TradeTransaction(transaction: Object) {
		const { players_by_id } = this.props;
		const from_user_id = transaction.value[0].from_team_id;
		const to_user_id = transaction.value[0].to_team_id;
		const total_from_trade = transaction.value
			.map( trade => trade).filter( t => t.from_team_id === from_user_id);
		const total_to_trade = transaction.value
			.map( trade => trade).filter( t => t.from_team_id === to_user_id);
		return (
			<TransactionPlayersWrapperInside>
				<TransactionPlayersLeft>
					<PlayerPTag>
						{transaction.value[0].from} <DeskSpan>initiated and traded:</DeskSpan>
					</PlayerPTag>
					{total_from_trade.map(player =>
						<StyledHistoryTradeInCell
							player={players_by_id[player.player_id]} key={player.player_id} />
					)}
				</TransactionPlayersLeft>
				<BorderedIconStyled background='#fff' className="hidden-mobile" >
					<Trade size="2" />
				</BorderedIconStyled>
				<TransactionPlayersRight>
					<PlayerPTag>
						With {transaction.value[0].to} <DeskSpan>for:</DeskSpan>
					</PlayerPTag>
					{total_to_trade.map(player =>
						<StyledHistoryTradeOutCell
							player={players_by_id[player.player_id]} key={player.player_id} />
					)}
				</TransactionPlayersRight>
			</TransactionPlayersWrapperInside>
		);
	}

	AddDropTransaction(transaction: Object) {
		const { players_by_id } = this.props;
		return (
			<TransactionPlayersWrapperInside>
				{ transaction.value[0].type === "Add" ?
					<TransactionPlayersLeft>
						<PlayerPTag>
							{transaction.value[0].to}
							<DeskSpan> selected the {transaction.value[0].from === "RFA's"
								&& 'Restricted'} Free Agent:
							</DeskSpan>
						</PlayerPTag>
						<StyledHistoryTradeInCell
							player={players_by_id[transaction.value[0].player_id]} />
					</TransactionPlayersLeft> : null}
				{ transaction.value.length === 2 ?
					<BorderedIconStyled background='#fff' className="hidden-mobile" >
						<FA size="2" />
					</BorderedIconStyled>
					: null}
				{ transaction.value[1] ?
					<TransactionPlayersRight>
						<PlayerPTag>
							And Released:
						</PlayerPTag>
						<StyledHistoryTradeOutCell
							player={players_by_id[transaction.value[1].player_id]} />
					</TransactionPlayersRight> : null}
				{ transaction.value[0].type === "Drop" ?
					<TransactionPlayersRightJustDrop>
						<p>
							{transaction.value[0].from} <DeskSpan>Released:</DeskSpan>
						</p>
						<StyledHistoryTradeOutCell
							player={players_by_id[transaction.value[0].player_id]} />
					</TransactionPlayersRightJustDrop> : null}
			</TransactionPlayersWrapperInside>
		);
	}

	renderTransactionTitle(transaction: Object) {
		const format = 'DD MMMM YYYY hh:mma';
		const transaction_date = moment(transaction.value[0].date_iso).format(format);
		const transaction_type = transaction.value[0].type === 'Trade'
			? ' - TEAM TO TEAM TRADE' : ` - ${transaction.value[0].from}`;
		if (transaction['value'][0].type !== 'Drop') {
			return (
				<TradeTitleStyled>
					{transaction_date}
					{transaction_type}
				</TradeTitleStyled>
			);
		}
		else {
			return (
				<TradeTitleStyledDrop>
					{transaction_date}
					{transaction_type}
				</TradeTitleStyledDrop>
			);
		}
	}

	renderTableRow(transaction: Object, index: number) {
		return (
			<div key={index}>
				<TradeTitleWrapper>
					{this.renderTransactionTitle(transaction)}
				</TradeTitleWrapper>
				{transaction['value'][0].type === 'Trade'
					? this.TradeTransaction(transaction) : this.AddDropTransaction(transaction)}
			</div>
		);
	}

	renderTableBody() {
		const { trade } = this.props;
		return (
			<TransactionHistoryDiv>
				{trade.map((transaction, index) => this.renderTableRow(transaction, index))}
			</TransactionHistoryDiv>
		);
	}

	render() {
		return (
			<StyledTransactionPlayersWrapper>
				{this.renderTableBody()}
			</StyledTransactionPlayersWrapper>
		);
	}
}


export default TransactionHistoryRFARow;


// WEBPACK FOOTER //
// ./src/pages/league/transactions/transactionHistory/transactionHistoryRFARow.js